import React from 'react';
import VisitorGrid from './VisitorGrid';

export default function Visitor() {
  return <VisitorGrid />;
}
